/* NMR CATEGORIES R120 — ARROW RAIL ONLY */
(() => {
  'use strict';

  const ROOT = '[data-nmr-categories]';

  function bind(section) {
    if (!section || section.dataset.nmrCategoriesBound === 'true') return;

    const viewport = section.querySelector('[data-nmr-categories-viewport]');
    const track = section.querySelector('[data-nmr-categories-track]');
    const prev = section.querySelector('[data-nmr-categories-prev]');
    const next = section.querySelector('[data-nmr-categories-next]');

    if (!viewport || !track) return;

    section.dataset.nmrCategoriesBound = 'true';

    function step() {
      const items = track.querySelectorAll('[data-nmr-category-item]');

      if (items.length > 1) {
        const distance = items[1].offsetLeft - items[0].offsetLeft;
        if (Math.abs(distance) > 1) return Math.abs(distance);
      }

      if (items.length === 1) {
        return items[0].getBoundingClientRect().width + 18;
      }

      return Math.max(160, viewport.clientWidth * .25);
    }

    function move(direction) {
      viewport.scrollBy({
        left:step() * direction,
        behavior:'smooth'
      });
    }

    prev?.addEventListener('click',() => move(-1));
    next?.addEventListener('click',() => move(1));
  }

  function init(root=document) {
    if (root.matches?.(ROOT)) bind(root);
    root.querySelectorAll?.(ROOT).forEach(bind);
  }

  init();

  document.addEventListener(
    'shopify:section:load',
    (event) => init(event.target)
  );
})();
